import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { DEFAULT_INPUT_EARLIEST_ALLOWED_DATE, DEFAULT_INPUT_LATEST_ALLOWED_DATE } from "abreact/input/date/AbDateInput";
import { AbDateTimeCommonInput } from "abreact/input/date/AbDateTimeCommonInput";
import { AbTimePrecision } from "abreact/input/date/AbTimeInput";
import { DateTimeUtils } from "abweb/utils/date/DateTimeUtils";
import { DateUtils } from "abweb/utils/DateUtils";
import * as React from "react";
const inRange = (date, earliest, latest) => {
  return earliest <= date && date <= latest;
};
const DEFAULT_EARLIEST_DATE = DEFAULT_INPUT_EARLIEST_ALLOWED_DATE.localMidnightDate;
const DEFAULT_LATEST_DATE = DateUtils.partialOverrideDate(DEFAULT_INPUT_LATEST_ALLOWED_DATE.localMidnightDate, {
  hour: 23,
  minute: 59,
  second: 59
});
const EXAMPLE = new Date(2000, 11, 31, 23, 59, 59);
export function AbDateTimeInput(props) {
  const {
    className,
    earliestDate,
    latestDate,
    format,
    ...rest
  } = props;
  const wrappedFormat = props.format ?? (props.timePrecision === AbTimePrecision.SECONDS ? DateTimeUtils.DATETIME_WITH_SECONDS : DateTimeUtils.DATETIME_WITH_MINUTES);
  const earliest = props.earliestDate ?? DEFAULT_EARLIEST_DATE;
  const latest = props.latestDate ?? DEFAULT_LATEST_DATE;
  // eslint-disable-next-line abinitio/exhaustive-deps
  const inRangeProp = React.useCallback(date => inRange(date, earliest, latest), [earliest.getTime(), latest.getTime()]);
  return /*#__PURE__*/React.createElement(AbDateTimeCommonInput, _extends({}, rest, {
    placeholder: props.placeholder ?? AbReactResources.datePicker_datetime_placeholder(),
    className: ReactUtils.classNamesString([props.className, "ab-date-time-input"]),
    format: {
      parse: wrappedFormat.parse,
      format: wrappedFormat.format,
      example: EXAMPLE
    },
    inRange: inRangeProp,
    getErrorString: (textIsValid, inRange) => {
      if (!textIsValid) return AbReactResources.datePicker_invalidDate_format(wrappedFormat.format(EXAMPLE));
      if (!inRange) return AbReactResources.datePicker_invalidDate_range(wrappedFormat.format(earliest), wrappedFormat.format(latest));
      return "";
    },
    equals: (d1, d2) => d1.getTime() === d2.getTime(),
    buttonProps: {
      value: props.value,
      format: wrappedFormat.format,
      withTime: true,
      timePrecision: props.timePrecision,
      defaultTime: props.defaultTime,
      earliestDate: earliest,
      latestDate: latest
    }
  }));
}
//# sourceMappingURL=AbDateTimeInput.js.map
